export default __webpack_public_path__ + "static/media/ape02.59b12c27.svg";